<template>
  <div>
    <b-input
      v-model="planCredentials.name"
      :error-messages="getErrorMessages(v$.name)"
      label="Назва"
      placeholder="Наприклад: Річний план аудиту 2026"
      @blur="v$.name.$touch()"></b-input>

    <b-select
      v-model="planCredentials.year"
      :disabled="dialog.action === 'update'"
      :error-messages="getErrorMessages(v$.year)"
      :items="yearOptions"
      label="Рік"
      placeholder="Оберіть рік"
      @blur="v$.year.$touch()"></b-select>
  </div>
</template>

<script lang="ts">
import { PropType, reactive } from 'vue'
import { Dialog } from '@/dialog'
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import { getErrorMessages } from 'best-modules/utils'
import { planCreate, planUpdate } from '@/requests/plan'

export default {
  name: 'Plan',
  props: {
    dialog: {
      type: Object as PropType<Dialog>,
      required: true,
    },
  },
  methods: { getErrorMessages },
  setup(props) {
    const planCredentials = reactive({
      name: null as any,
      year: null as any,
    })

    const currentYear = new Date().getFullYear()
    const yearOptions = [
      String(currentYear - 1),
      String(currentYear),
      String(currentYear + 1),
    ]

    const rules = {
      name: { required },
      year: { required },
    }
    const v$ = useVuelidate(rules, planCredentials)

    if (props.dialog.action === 'update') {
      planCredentials.name = props.dialog.dialogData.plan.name
      planCredentials.year = props.dialog.dialogData.plan.year
    }

    const submit = () => {
      if (props.dialog.action === 'update') {
        return planUpdate(props.dialog.dialogData.plan.id, {
          name: planCredentials.name,
        })
      } else {
        return planCreate(planCredentials)
      }
    }

    return { planCredentials, v$, submit, yearOptions }
  },
}
</script>

<style lang="scss" scoped></style>
